export const menuItems = [
  {
    title: "회사소개",
    link: "/ceo",
    submenu: [
      {
        title: "Ceo",
        link: "/ceo",
      },
      {
        title: "개요",
        link: "/overview",
      },
      {
        title: "연혁",
        link: "/history",
      },
      {
        title: "오시는 길",
        link: "/location",
      },
    ],
  },
  {
    title: "제품정보",
    link: "/software",
    submenu: [
      {
        title: "소프트웨어",
        link: "/software",
      },
      {
        title: "의료기기",
        link: "/device",
      },
      {
        title: "제약",
        link: "/medicine",
      },
    ],
  },
  {
    title: "PR센터",
    link: "/news",
    submenu: [
      {
        title: "활동사항",
        link: "/news",
      },
      {
        title: "홍보자료",
        link: "/pr",
      },
    ],
  },
  {
    title: "고객센터",
    link: "/inquiry",
    submenu: [
      {
        title: "제품문의",
        link: "/inquiry",
      },
      {
        title: "A/S접수",
        link: "/as_support",
      },
      {
        title: "인재채용",
        link: "/career",
      },
    ],
  },
];
